import React from 'react';
import { Routes, Route } from 'react-router-dom';

// pages
import Recording from './Recording';
import POA from './POA';
import PlanConf from './PlanConf';
import Agent from './Agent';

function Acknowledge() {
  return (
    <Routes>
      <Route path="recording" element={<Recording />} />
      <Route path="agent" element={<Agent />} />
      <Route path="poa" element={<POA />} />
      <Route path="plan-conf" element={<PlanConf />} />
    </Routes>
  );
}

export default Acknowledge;
